import React from 'react';
import PropTypes from 'prop-types';
import { Form, withFormik } from 'formik';
import * as Yup from 'yup';
import { Regex } from '../../shared/helpers';
import './FreeCommentForm.css';

const FreeComment = ({ handleFreeCommentInputChange, comment }) => (
  <Form className="col-12" autoComplete="off">
    <div className="card card-project freecommentform-card border-0 mb-3 p-lg-3 reference-card__content">
      <div className="card-body">
        <div className="form-row">
          <div className="col">
            <div className="row align-items-center">
              <div className="col" />
              <div className="col text-right" />
            </div>
          </div>
        </div>
        <div className="form-row w-100">
          <div className="col-12 mt-3">
            <textarea
              rows="8"
              placeholder="Feel free to provide as much detail about your project as you would like"
              className="form-control reference-card__textarea"
              name="comment"
              defaultValue={comment}
              onChange={event => handleFreeCommentInputChange(event)}
            />
          </div>
        </div>
      </div>
    </div>
  </Form>
);

FreeComment.propTypes = {
  handleFreeCommentInputChange: PropTypes.func,
  comment: PropTypes.string,
};

const FreeCommentForm = withFormik({
  validateOnBlur: true,
  validateOnChange: true,
  enableReinitialize: true,
  validationSchema: Yup.object().shape({
    comment: Yup.string()
      .matches(Regex.site, 'This video URL is not valid')
      .nullable(),
  }),
  displayName: 'FreeCommentForm',
})(FreeComment);

export default FreeCommentForm;



// WEBPACK FOOTER //
// ./src/components/FreeCommentForm/FreeCommentForm.js